import { MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export default function WhatsAppButton() {
  const link = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(SITE.whatsappMessage)}`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 group"
    >
      <span className="absolute -top-11 right-0 whitespace-nowrap bg-slate-900 text-white text-xs font-medium px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition">
        Chat on WhatsApp
      </span>
      <span className="pulse-ring inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white shadow-xl hover:scale-105 transition-transform">
        <MessageCircle className="w-7 h-7 md:w-8 md:h-8" fill="currentColor" />
      </span>
    </a>
  );
}
